export const productosPlataformas = [
  {
    id: 202,
    categoria: 'plataformas',
    nombre: 'PLATAFORMA ',
    descripcion: 'herramienta práctica, económica y confiable para tareas de pesaje en comercios, industrias, depósitos y centros logísticos',
    descripcion2: 'Versión de mayor superficie para cargas voluminosas. Estructura resistente y opciones de capacidad hasta 5 toneladas.',
    imagen: '/imagenes/productos/Plataformas/default_plataforma1.webp',
    caracteristicas: [
      {
        titulo: 'Características',
        items: [
          '4 PCS CHEAR BEAM Cargar celda',
          'Estructura metálica con base reforzada y cubierta diamantada',
          'Rampa opcional',
          'Caja de conexiones impermeables para la vida útil más larga',
          'Punto único y calibración lineal',
          'Indicadores opcionales incluyendo: LP-7516, LP7510, CAS-200CI, HFL PC-200',
          'Ideal para necesidades de pesaje seco en aplicaciones industriales y comerciales'
        ]
      }
    ],
    opciones: [
      {
        id: 'dimension-100x100',
        nombre: '100x100 cm',
      },
      {
        id: 'dimension-120x120',
        nombre: '120x120 cm',
      },
      {
        id: 'dimension-150x150',
        nombre: '150x150 cm',
      }
      
      
      
    ],
    opciones2: [
      {
        id: 'plataforma-600kg ',
        nombre: '600kg',
      },
      {
        id: 'plataforma-1000kg',
        nombre: '1000kg',
      },
      {
        id: 'plataforma-1500kg',
        nombre: '1500kg',
      },
      {
        id: 'plataforma-2000kg',
        nombre: '2000kg',
      },
      {
        id: 'plataforma-3000kg',
        nombre: '3000kg',
      },
      {
        id: 'plataforma-5000kg',
        nombre: '5000kg',
      }
    ],
    imagenes: [
      '/imagenes/productos/Plataformas/default_plataforma1.webp',
      '/imagenes/productos/Plataformas/default_plataforma2.webp',
      '/imagenes/productos/Plataformas/default_plataforma3.webp',
    ]
  },
  {
    id: 203,
    categoria: 'plataformas',
    nombre: 'PLATAFORMA INOX',
    descripcion: 'balanza de acero inoxidable es una solución confiable y económica para aplicaciones que requieren higiene, resistencia a la corrosión y fácil limpieza',
    descripcion2: 'Construcción 100% inoxidable para ambientes higiénicos. Componentes IP65/IP67 y fácil limpieza.',
    imagen: '/imagenes/productos/Plataformas/inox1.webp',
    caracteristicas: [
      {
        titulo: 'Caracteristicas principales',
        items: [
          '•	Estructura y plataforma 100% en acero inoxidable',
          '•	Indicadores opcionales incluyendo: LP7510 SS, CAS-200CI SS, XK3119SS',
          '•	Celdas de carga con protección IP65 / IP67, resistentes al agua y polvo',
        ]
      },
      {
        titulo: 'Ventajas del acero inoxidable',
        items: [
          '•	Ideal para ambientes donde se requiere lavado frecuente',
          '•	Resistente a químicos, humedad y grasas',
          '•	Cumple con normas básicas de inocuidad alimentaria',
          '•	Apta para contacto indirecto con alimentos',
        ]
      },
    ],
    opciones: [
      {
        id: 'plataforma-inox-120',
        nombre: '120x120',
      },
      {
        id: 'plataforma-inox-150',
        nombre: '150x150',
      },

    ],
    imagenes: [
      '/imagenes/productos/Plataformas/inox1.webp',
      '/imagenes/productos/Plataformas/inox2.webp',
      '/imagenes/productos/Plataformas/inox3.webp',

    ]
  },
  {
    id: 204,
    categoria: 'plataformas',
    nombre: 'PLATAFORMA NACIONAL',
    descripcion: 'La plataforma de fabricación nacional es un equipo de pesaje diseñado y producido localmente, cumpliendo con los más altos estándares de calidad',
    descripcion2: 'Fabricación local a medida: dimensiones, capacidad y terminaciones configurables según requerimiento.',
    imagen: '/imagenes/productos/Plataformas/nacional1.webp',
    caracteristicas: [
      {
        titulo: 'Caracteristicas principales',
        items: [
          '•	Dimensiones de plataforma personalizadas, según requerimiento del cliente (ej. 120x120 cm, 150x200 cm, 200x200 cm, etc.)',
          '•	Material de la estructura: Acero estructural de alta resistencia', 
          '•	Superficie: lisa (según preferencia)',
          '•	Refuerzos internos: Perfiles estructurales soldados para garantizar robustez y durabilidad',
          '•	Terminación: Pintura epoxi de alta resistencia ',
        ]
      },
      {
        titulo: 'Capacidad y Precisión',
        items: [
          '•	Capacidad máxima: Desde 500 kg hasta 10.000 kg (según diseño)',
          '•	Resolución / Precisión: Desde 0,1 kg hasta 2 kg, configurable según uso',
        ]
      },
      {
        titulo: 'Sistema de pesaje',
        items: [
          '•	Celdas de carga: 4 unidades, tipo shear beam o doble viga, de acero aleado o inoxidable',
          '•	Modo de pesaje: Peso neto, peso bruto, peso tara, peso neto + tara',
        ]
      },
      {
        titulo: 'Indicador digital ',
        items: [
          '•	Funciones: Tara, cero, acumulación, conteo de piezas, pesaje dinámico, etc.',
          '•	Pantalla LED o LCD retroiluminada',
          '•	Opcional: Con impresora térmica o conexión a PC / software',
        ]
      },
    ],
    opciones: [
      {
        id: 'plataforma-nacional-120',
        nombre: '120x120',
      },
      {
        id: 'plataforma-nacional-150',
        nombre: '150x150',
      },
      {
        id: 'plataforma-nacional-personalizada',
        nombre: 'Personalizada',
      }

    ],
    imagenes: [
      '/imagenes/productos/Plataformas/nacional1.webp',
      '/imagenes/productos/Plataformas/nacional2.webp',

    ]
  },
  {
    id: 205,
    categoria: 'plataformas',
    nombre: 'BALANZA PEDESTAL',
    descripcion: 'solución compacta, robusta y precisa para tareas de pesaje en entornos comerciales, industriales o logísticos.',
    descripcion2: 'Equipo compacto con columna e indicador LP7516. Autonomía extendida y múltiples capacidades y dimensiones.',
    imagen: '/imagenes/productos/Plataformas/pedestal1.webp',
    caracteristicas: [
      {
        titulo: 'Plataforma',
        items: [
          'Material: Estructura metálica reforzada, cubierta lisa inox',
          'Precisión: Desde 1 g a 200 g (según capacidad y dimensión)',
          'Célula de carga de alta precisión, con protección IP65/IP67'
        ]
      },
      {
        titulo: 'Indicador LP7516',
        items: [
          'Pantalla LED de alto brillo o LCD retroiluminada',
          'Carcasa en ABS',
          'Montaje sobre columna o sobremesa'
        ]
      },
      {
        titulo: 'Alimentación',
        items: [
          'Batería interna recargable + adaptador 220V',
          'Autonomía: Hasta 60 horas de uso continuo',
          'Indicador de nivel de batería'
        ]
      },
      {
        titulo: 'Aplicaciones',
        items: [
          'Comercios mayoristas y minoristas',
          'Industrias y talleres',
          'Depósitos, embalaje y control de stock',
          'Laboratorios, distribuidoras y puntos de control de carga'
        ]
      }
    ],
    opciones: [
      {
        id: 'dimension-30x40',
        nombre: '30x40 cm',
      },
      {
        id: 'dimension-45x60',
        nombre: '45x60 cm',
      },
      {
        id: 'dimension-personalizada',
        nombre: 'Personalizada',
      }
    ],
    opciones2: [
      {
        id: 'plataforma-pedestal-30',
        nombre: '30kg',
      },
      {
        id: 'plataforma-pedestal-60',
        nombre: '60kg',
      },
      {
        id: 'plataforma-pedestal-100',
        nombre: '100kg',
      },
      {
        id: 'plataforma-pedestal-200',
        nombre: '200kg',
      },
      {
        id: 'plataforma-pedestal-300',
        nombre: '300kg',
      },
      {
        id: 'plataforma-pedestal-500',
        nombre: '500kg',
      }
    ],
    imagenes: [
      '/imagenes/productos/Plataformas/pedestal1.webp',
      '/imagenes/productos/Plataformas/pedestal2.webp',
      '/imagenes/productos/Plataformas/pedestal3.webp',
      '/imagenes/productos/Plataformas/pedestal4.webp',
      '/imagenes/productos/Plataformas/pedestal5.webp',
    ]
    },
  {
    id: 206,
    categoria: 'plataformas',
    nombre: 'TRANSPALETA CON PESAJE',
    descripcion: 'La transpaleta con pesaje es una solución práctica, robusta y eficiente para el manejo y control de cargas',
    descripcion2: 'Transporte y pesaje en un solo equipo. Estructura reforzada, indicador digital y opciones de conectividad.',
    imagen: '/imagenes/productos/Plataformas/transpaleta1.webp',
    caracteristicas: [
      {
        titulo: 'Características',
        items: [
          'Capacidad de carga: Hasta 2,000 / 2,500 kg (según modelo)',
          'Pesaje integrado: Con sistema electrónico de alta precisión',
          'Resolución: Desde 0.5 kg (según configuración)',
          'Estructura: Robusta, construida con acero reforzado',
          'Horquillas estándar: 1150 mm de largo x 550 mm de ancho (otros tamaños disponibles)',
          'Ruedas: Poliuretano o nailon, suaves y resistentes',
        ]
      },
      {
        titulo: 'Indicador Digital:LCD o LED fácil de leer, con funciones para:',
        items: [
          '• Tare (Tara)',
          '• Zero (Cero)',
          '• Acumulación',
          '• Pesaje bruto / neto',
        ]
      },
      {
        titulo: 'Opcionales',
        items: [
          'Impresora térmica integrada',
          'Conectividad: Bluetooth / RS232 / USB / WiFi',
          'Certificación de calibración'
        ]
      }
    ],
    opciones: [
      {
        id: 'transpaleta-2000',
        nombre: '2000kg',
      },
      {}
    ],
    imagenes: [
      '/imagenes/productos/Plataformas/transpaleta1.webp',
      '/imagenes/productos/Plataformas/transpaleta2.webp',
      '/imagenes/productos/Plataformas/transpaleta3.webp',

    ]
  },
  {
    id: 207,
    categoria: 'plataformas',
    nombre: 'BALANZA DE POLINES',
    descripcion: 'La balanza de polines es una solución práctica, robusta y eficiente para el manejo y control de cargas',
    descripcion2: 'Transporte y pesaje en un solo equipo. Estructura reforzada, indicador digital y opciones de conectividad.',
    imagen: '/imagenes/productos/Plataformas/rodillos1.webp',
    caracteristicas: [
      {
        titulo: 'Características',
        items: [
          ' personalizables: diámetro, paso y ancho útil según producto; opciones de rodillo libre, freno o motorizado. ',

          'Capacidades y medidas a pedido (referencia: de 60 kg hasta 1.500 kg y desde 300×400 mm hasta 1500×1500 mm, según versión).   ',
        ]
      },
      {
        titulo: 'Estructuras a elección',
        items: [
          'Acero inoxidable para ambientes húmedos o sanitarios.',
          'Acero carbono con pintura epóxica o galvanizado para uso industrial.'
        ]
      }
    ],
    opciones: [
      {
        id: 'polines',
        nombre: 'BALANZA DE POLINES',
        
      },
    ],
    imagenes: [
      '/imagenes/productos/Plataformas/rodillos1.webp',
      '/imagenes/productos/Plataformas/rodillos2.webp',


    ]
  },
  {
    id: 208,
    categoria: 'plataformas',
    nombre: 'BALANZA DE PEDESTAL INOXIDABLE',
    descripcion: 'Plataforma de pesaje tipo bench, 100% acero inoxidable AISI 304, pensada para uso intensivo en procesos con humedad, lavado y ambientes corrosivos. ',
    descripcion2: 'Plataforma de pesaje tipo bench, 100% acero inoxidable AISI 304, pensada para uso intensivo en procesos con humedad, lavado y ambientes corrosivos. Estructura soldada robusta, cubierta en INOX de 1,5 mm, celda encapsulada de acero inoxidable con protección IP67/IP68 y patas niveladoras en INOX. Ideal para industria alimentaria, pesquera, agrícola y logística. ',
    imagen: '/imagenes/productos/Plataformas/fullinox1.webp',
    caracteristicas: [
      {
        titulo: 'Características',
        items: [
          '•	Construcción: AISI 304, superficies sanitarias y de fácil limpieza.',
          '•	Cubierta: plancha inoxidable 1,5 mm.',
          '•	Celda de carga: encapsulada en INOX, sellada (IP67/68).',
          '•	Apoyo: 4 patas niveladoras inox M12; opción ruedas.',
          '•	Conexión: Caja sumadora/cableado en INOX (según capacidad).',
          '•	Aplicación: salas de proceso, cámaras de frío y líneas de empaque. ',
          
        ]
      },
      {
        titulo: 'Modelos:',
        items: [
          '•	30×40 cm: capacidades 30/60 kg',
          '•	40×50 cm: capacidades 150/300 kg ',
          '•	50x60cm: capacidad 300/500 kg',
          '•	60×60 cm: capacidad 500 kg',
          '•	60×70 cm: capacidad 500 kg',
          
        ]
      }
    ],
    opciones: [
      {
        id: 'fullinox-3040',
        nombre: '30×40 cm capacidades 30/60 kg  ',
        
      },
      {
        id: 'fullinox-4050',
        nombre: '40×50 cm capacidades 150/300 kg',
        
      },
      
      {
        id: 'fullinox-5060',
        nombre: '50x60cm capacidad 300/500 kg',
        
      },
      
      {
        id: 'fullinox-6060',
        nombre: '60×60 cm capacidad 500 kg',
        
      },
      {
        id: 'fullinox-6070',
        nombre: '60×70 cm capacidad 500 kg',
        
      },
    
      
    ],
    imagenes: [
      '/imagenes/productos/Plataformas/fullinox1.webp',
      '/imagenes/productos/Plataformas/fullinox2.webp',
      '/imagenes/productos/Plataformas/fullinox3.webp',
      '/imagenes/productos/Plataformas/fullinox4.webp',

    ]
  },
]; 